import React from 'react';
import MoonLoader from 'react-spinners/MoonLoader';
import styled from 'styled-components';
import { colors, misc } from '../styles/utilities/settings';

const Loading = ({ justSpinner }) => (
  <SLoading>
    <div id="progress">
      <MoonLoader sizeUnit="px" size={70} color={colors.blue} />
      <div
        className="bar"
        style={{
          display: justSpinner && 'none',
        }}
      >
        <div />
      </div>
      <p
        style={{
          display: justSpinner && 'none',
        }}
      />
    </div>
  </SLoading>
);

export default Loading;

export const SLoading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  overflow: hidden;

  * {
    box-sizing: content-box;
  }

  .bar {
    height: 7px;
    width: 0%;
    max-width: 800px;
    margin: 20px auto 0;
    transition-duration: ${misc.animSpeed};

    div {
      height: 100%;
      margin: 0 auto;
      background-color: ${colors.blue};
    }
  }

  p {
    text-align: center;
    margin-top: 10px;
    color: ${colors.blue};
  }
`;
